import { H2RInput } from "../../imports";
import {
	ReplaceWithDataSource,
} from "../helpers/variable";

export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<>
      <H2RInput
				label="Name"
				value={cue.name}
        placeholder="Progress"
				onChange={(value) => {
					onUpdate({
						name: value,
					});
				}}
			/>
			<H2RInput
				label="Percent complete (0 - 100)"
        type="number"
        min={0}
        max={100}
        step={1}
				value={cue.percent}
				onChange={(value) => {
					onUpdate({
						percent: value,
					});
				}}
			/>
		</>
	);
};

export const GraphicCueContent = ({
	cue,
}) => {
	return (
		<div className="overflow-ellipsis w-48 md:w-auto max-w-xs md:max-w-sm lg:max-w-lg whitespace-nowrap overflow-hidden">
			<div className="font-semibold ">
				{cue.percent}% • {cue.name || "Progress"}{" "}
			</div>
		</div>
	);
};
